import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useAnnualEvolutionRegisters from './hooks/useAnnualEvolutionRegisters';

export const AnnualEvolutionRegisters = () => {
    const { chartConfig } = useAnnualEvolutionRegisters();

    return (
        <ChartContainer
            title={"Evolução Anual do cadastramento"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
